import type { Severity } from "@shared/constants/severity";

/**
 * Record rows inside a SectionCard wash (docs/v2-core/STYLE.md, "boxed
 * squares"): soft glass with a white ring and a faint sky shadow, never a
 * grey border. Literal class strings for Tailwind's JIT; compose with cn().
 */
export const ROW =
  "rounded-2xl bg-white/80 p-4 ring-1 ring-white shadow-[0_8px_24px_-18px_rgb(2_132_199/0.35)]";

/** An inactive / ended / revoked record: the same row, faded back toward the wash. */
export const ROW_MUTED = "rounded-2xl bg-white/45 p-4 ring-1 ring-white/70";

/** The quiet "Loading…" line inside a section (neutral-600 stays AA on every wash). */
export const INLINE_STATUS = "flex items-center gap-2 text-sm text-neutral-600";

/**
 * Allergy rows on the parent's profile: a soft severity tint and ring, with
 * the SeverityBadge carrying the word. (The caregiver view and the EIF keep
 * their own stronger emergency styling, SEVERITY_CARD_CLASSES.)
 */
export const SEVERITY_ROW: Record<Severity, string> = {
  mild: "rounded-2xl bg-yellow-50/90 p-4 ring-1 ring-yellow-200",
  moderate: "rounded-2xl bg-amber-50/90 p-4 ring-1 ring-amber-200",
  severe: "rounded-2xl bg-red-50/90 p-4 ring-1 ring-red-200",
};
